var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classic_case container"},[_c('div',{staticClass:"title"},[_c('h4',[_vm._v("医学院排行榜")]),_vm._v(" "),_c('nuxt-link',{attrs:{"target":"_blank","to":{
        path: '/historyTop',
        query: { deptID: this.$route.query.deptID },
      }}},[_c('button',{staticClass:"check_all"},[_vm._v("查看全部")])])],1),_vm._v(" "),_c('HotNews',{attrs:{"info":_vm.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }